import React from "react";
import { Formik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import { CustomSelect, InterviewTypeOptions } from "../../../../../../../../_helpers/Helpers";

export function InterviewEditForm({
  btnRef,
  interview,
  saveInterview
}) {
  return (
    <Formik
      enableReinitialize={true}
      initialValues={interview}
      onSubmit={(values) => {
        saveInterview(values);
      }}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>          
          <Form.Group as={Row} controlId="date">
            <Form.Label column sm={4}>
              Görüşme Tarihi<span> *</span>
            </Form.Label>
            <Col sm={8}>
              <Form.Control type="date" value={values.date} placeholder="Görüşme Tarihi" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="interviewType">
            <Form.Label column sm={4}>
              Görüşme Türü
            </Form.Label>
            <Col sm={8}>
              <CustomSelect 
                options={InterviewTypeOptions}
                value={values.interviewType}
                onChange={option => setFieldValue("interviewType", option.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="trackingDate">
            <Form.Label column sm={4}>
              Takip Tarihi<span> *</span>
            </Form.Label>
            <Col sm={8}>
              <Form.Control type="date" value={values.trackingDate} placeholder="Takip Tarihi" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="explanation">
            <Form.Label column sm={4}>
              Açıklama<span> *</span>
            </Form.Label>
            <Col sm={8}>
              <Form.Control 
                as="textarea"
                rows="2"
                placeholder="Açıklama"
                value={values.explanation}
                onChange={handleChange}
              />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}